import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import MainPage from './components/MainPage';
import ProcedurePage from './components/ProcedurePage';
import ContactPage from './components/ContactPage';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/procedure/:procedureSlug" element={<ProcedurePage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </div>
  );
}

export default App;